import '@angular/compiler';
import { PageAdminReportsComponent } from './page.admin.reports/page.admin.reports.component';
import { PageAdminLoginComponent } from './page.admin.login/page.admin.login.component';
import { LayoutGgeea_adminComponent } from './layout.ggeea_admin/layout.ggeea_admin.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminChatsComponent } from './page.admin.chats/page.admin.chats.component';
import { PageAdminIndexComponent } from './page.admin.index/page.admin.index.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PageAdminStatsComponent } from './page.admin.stats/page.admin.stats.component';
import { PageRootComponent } from './page.root/page.root.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';

const INDEX_PAGE = "main";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutGgeea_adminComponent,
        "children": [
            {
                "path": "admin/reports",
                component: PageAdminReportsComponent,
                "app_id": "page.admin.reports"
            },
            {
                "path": "admin/chats",
                component: PageAdminChatsComponent,
                "app_id": "page.admin.chats"
            },
            {
                "path": "admin/dashboard",
                component: PageAdminDashboardComponent,
                "app_id": "page.admin.dashboard"
            },
            {
                "path": "admin/settings/:tab?",
                component: PageAdminSettingsComponent,
                "app_id": "page.admin.settings"
            },
            {
                "path": "admin/stats",
                component: PageAdminStatsComponent,
                "app_id": "page.admin.stats"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "admin/login",
                component: PageAdminLoginComponent,
                "app_id": "page.admin.login"
            },
            {
                "path": "admin",
                component: PageAdminIndexComponent,
                "app_id": "page.admin.index"
            },
            {
                "path": "",
                component: PageRootComponent,
                "app_id": "page.root"
            },
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    path: '',
    redirectTo: INDEX_PAGE,
    pathMatch: 'full'
}, {
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
